import { Dispatch } from 'redux';
import { AppState } from '../types/app-state';
import { getAllOrganisations, updateOrganisationState, updateMemberState } from '../services/organisation';
import { Organisation } from '../types/organisation';
import { Action } from '../types/action';
import * as Constants from './admin.constants';
export interface LoadOrganisationsDoneAction extends Action {
  organisations: Organisation[];
}

export interface UpdateOrganisationStateRequestAction extends Action {
  payload: {
    orgId: string;
    deactivate: boolean;
  };
}

export interface UpdateOrganisationStateSuccessAction extends Action {
}

export interface UpdateOrganisationStateFailedAction extends Action {
  payload: {
    orgId: string;
    deactivate: boolean;
    error: string;
  };
}

export interface UpdateMemberStateRequestAction extends Action {
  payload: {
    orgId: string;
    memberId: string;
    active: boolean;
  };
}

export interface UpdateMemberStateSuccessAction extends Action {
}

export interface UpdateMemberStateFailedAction extends Action {
  payload: {
    orgId: string;
    memberId: string;
    active: boolean;
    error: string;
  };
}



export function InitialiseManageOrganisation() {
  return async (dispatch: Dispatch<any>) => {
    dispatch({ type: Constants.MANAGE_ORG_INITIALISE });
    dispatch(LoadOrganisations());
  };
}

export function LoadOrganisations() {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    dispatch({ type: Constants.LOAD_ORGANISATIONS });
    try {
      const { token } = getState().auth;

      if (token) {
        const { status, data, message } = await getAllOrganisations(token);
        if (status === 1 && data) {
          dispatch(LoadOrganisationsDone(data));
        } else {
          throw new Error(status === -2 ? 'A server error occurred' : message);
        }
      } else {
        throw new Error('User not authenticated');
      }

    } catch (error) {
      // dispatch(SetErrorMessage(error.message));
    }
  };
}

export function LoadOrganisationsDone(organisations: Organisation[]): LoadOrganisationsDoneAction {
  return {
    type: Constants.LOAD_ORGANISATIONS_DONE,
    organisations
  };
}

export function UpdateOrganisationState(orgId: string, deactivate: boolean) {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    dispatch(UpdateOrganisationRequest(orgId, deactivate));
    try {
      const { token } = getState().auth;

      if (token) {
        const { status, message } = await updateOrganisationState(token, orgId, deactivate);
        if (status === 1) {
          dispatch(UpdateOrganisationSuccess());
          dispatch(LoadOrganisations());
        } else {
          throw new Error(status === -2 ? 'A server error occurred' : message);
        }
      } else {
        throw new Error('User not authenticated');
      }

    } catch (error) {
      dispatch(UpdateOrganisationFailed(orgId, deactivate, JSON.stringify(error)));
      dispatch(LoadOrganisations());
    }
  };
}

export function UpdateOrganisationRequest(orgId: string, deactivate: boolean): UpdateOrganisationStateRequestAction {
  return {
    type: Constants.ORGANISATION_STATE_UPDATE_REQUEST,
    payload: {
      orgId, deactivate
    }
  };
}

export function UpdateOrganisationSuccess(): UpdateOrganisationStateSuccessAction {
  return {
    type: Constants.ORGANISATION_STATE_UPDATE_SUCCESS
  };
}

export function UpdateOrganisationFailed(orgId: string, deactivate: boolean, error: string):
  UpdateOrganisationStateFailedAction {
  return {
    type: Constants.ORGANISATION_STATE_UPDATE_FAILED,
    payload: { orgId, deactivate, error }
  };
}

export function UpdateMemberState(orgId: string, memberId: string, active: boolean) {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    dispatch(UpdateMemberRequest(orgId, memberId, active));
    try {
      const { token } = getState().auth;

      if (token) {
        const { status, message } = await updateMemberState(token, orgId, memberId, active);
        if (status === 1) {
          dispatch(UpdateOrganisationSuccess());
          dispatch(LoadOrganisations());
        } else {
          throw new Error(status === -2 ? 'A server error occurred' : message);
        }
      } else {
        throw new Error('User not authenticated');
      }

    } catch (error) {
      dispatch(UpdateMemberFailed(orgId, memberId, active, JSON.stringify(error)));
      dispatch(LoadOrganisations());
    }
  };
}

export function UpdateMemberRequest(
  orgId: string,
  memberId: string,
  active: boolean
): UpdateMemberStateRequestAction {
  return {
    type: Constants.MEMBER_STATE_UPDATE_REQUEST,
    payload: {
      orgId, memberId, active
    }
  };
}

export function UpdateMemberSuccess(): UpdateMemberStateSuccessAction {
  return {
    type: Constants.MEMBER_STATE_UPDATE_SUCCESS
  };
}

export function UpdateMemberFailed(
  orgId: string,
  memberId: string,
  active: boolean,
  error: string
): UpdateMemberStateFailedAction {
  return {
    type: Constants.MEMBER_STATE_UPDATE_FAILED,
    payload: { orgId, memberId, active, error }
  };
}

export type All
  = Action
  | LoadOrganisationsDoneAction
  | UpdateOrganisationStateRequestAction
  | UpdateOrganisationStateSuccessAction
  | UpdateOrganisationStateFailedAction
  | UpdateMemberStateRequestAction
  | UpdateMemberStateSuccessAction
  | UpdateMemberStateFailedAction;